export default __webpack_public_path__ + "static/SRUS 3147 - Especification Del Producto y Datos Técnicos-844eb12d8451243ad0febff70a3ff4d7.pdf";